import React from 'react'
import { Col, List, Row, Typography } from 'antd'
import CustomList from '../../../components/Shared/CustomList'
import { GeneralTitle } from '../../../components/Shared'

const { Title, Paragraph } = Typography

const services = [
	'Workflow Automation (RPA)',
	'AI-Powered Chatbots',
	'Predictive Analytics',
	'Machine Learning Models',
	'Natural Language Processing',
	'Custom AI Integrations'
]

const AutomationsAndAi = () => {
	return (
		<>
			<GeneralTitle>Automations & AI</GeneralTitle>

			<Row gutter={[20, 20]} justify="space-between" align="middle">
				<Col xs={24} sm={24} md={14} lg={14}>
					<Title level={4}>
						Empower Your Business with Intelligent Automation
					</Title>
					<Paragraph>
						Leverage cutting-edge AI and automation to streamline
						your operations, eliminate manual bottlenecks, and
						unlock new levels of productivity. Our solutions are
						designed to adapt as you grow, delivering measurable
						ROI.
					</Paragraph>
					<Paragraph>
						We cover WordPress, mobile apps (Android, iOS, using
						EXPO and React Native), Python automation, Crypto
						Analysis and statistics, and custom web solutions.
					</Paragraph>
					<Title level={5}>
						Transformative Technology at Your Fingertips
					</Title>
					<Paragraph>
						From Robotic Process Automation (RPA) to bespoke machine
						learning models, we offer end-to-end services: strategy,
						development, deployment, and ongoing optimization.
					</Paragraph>
					<Title level={5}>Data-Driven Decisions</Title>
					<Paragraph>
						Turn raw data into actionable insights with predictive
						analytics, intelligent dashboards, and automated data
						pipelines that power smarter decision-making.
					</Paragraph>
					<CustomList
						dataSource={services}
						renderItem={(item) => <List.Item>{item}</List.Item>}
					/>
				</Col>
				<Col xs={24} sm={24} md={10} lg={10}>
					<img
						width="100%"
						src={`${process.env.PUBLIC_URL}https://webackit.com/wp-content/uploads/2024/03/webackit-services-diagram-business.svg`}
						alt="WordPress Services Diagram"
					/>
				</Col>
			</Row>
		</>
	)
}

export default AutomationsAndAi
